module.exports = __webpack_public_path__ + "img/spx.0dc817c1.png";